import React, { useState } from "react";
import PillInput from "./InputFieldWithPills";
import { TYPE_LIST, MONTH_LIST } from "../data.js";
import { Modal, Box, Typography, RadioGroup, FormControlLabel, Radio, Divider, Button, MenuItem, Select } from "@mui/material";
import { GlobalState } from "context/GlobalContext";
import axios from "axios";
import FileSaver from "file-saver";

const style = {
	position: "absolute",
	top: "50%",
	left: "50%",
	transform: "translate(-50%, -50%)",
	width: 500,
	bgcolor: "background.paper",
	boxShadow: 24,
	p: 3,
	borderRadius: 2,
};
function DownloadModal({ open, onClose }) {
	const [mode, setMode] = useState("");
	const [data, setData] = useState(null);
	const { setSnackBar, snackBar, setSnackBarOpen, setLoadingOpen } = GlobalState();
	const [isFormValid, setIsFormValid] = useState(false);

	const handleModeChange = (e) => {
		setMode(e.target.value);
		if (e.target.value === "all") {
			setIsFormValid(true); // enable immediately
		} else {
			setIsFormValid(false); // wait for custom form validation
		}
	};

	const handleFormValidity = (valid) => {
		setIsFormValid(valid);
	};

	const handleDownload = async () => {
		if (mode === "all") {
			await axios
				.post("/api/exclusion/download", {}, { responseType: "blob" })
				.then((res) => {
					const url = URL.createObjectURL(res.data);
					FileSaver.saveAs(url, `EXCLUDED_DATA.csv`);
					setSnackBarOpen(true);
					setSnackBar({
						...snackBar,
						message: "File downloaded successfully",
						severity: "success",
						anchorOrigin: { horizontal: "center", vertical: "top" },
					});
				})
				.catch((err) => {
					setSnackBarOpen(true);
					setSnackBar({
						...snackBar,
						message: `Failed to download file ${err}`,
						severity: "error",
						anchorOrigin: { horizontal: "center", vertical: "top" },
					});
				});
			// API call for full download
		} else {
			console.log("Downloading with custom filters...");
			// API call with custom filters
		}
		onClose();
	};

	const handleTypeChange = (event) => {
		const value = event.target.value;
		if (value === "ORDER_ID") {
			setData({ type: "ORDER_ID", values: [] });
		} else if (value === "VOUCHER") {
			setData({ type: "VOUCHER", month: "", values: [] });
		} else {
			setData(null);
		}
	};

	const handleClear = () => {
		if (data?.type === "ORDER_ID") {
			setData({ type: "ORDER_ID", values: [] });
		} else if (data?.type === "VOUCHER") {
			setData({ type: "VOUCHER", month: "", values: [] });
		}
	};

	return (
		<Modal open={open} onClose={onClose}>
			<Box sx={style}>
				<Typography variant="h6" gutterBottom>
					Download Options
				</Typography>

				<RadioGroup value={mode} onChange={handleModeChange}>
					<FormControlLabel value="all" control={<Radio />} label="Download All" />
					<FormControlLabel value="custom" control={<Radio />} label="Custom" disabled />
				</RadioGroup>

				{mode === "custom" && (
					<>
						<Divider sx={{ my: 2 }} />
						{/* Reuse the ExclusionForm component */}
						<Box sx={{ display: "flex", flexDirection: "column", gap: 2, mt: 1 }}>
							{/* Type Dropdown */}
							<Select value={data?.type || ""} onChange={handleTypeChange} displayEmpty fullWidth>
								<MenuItem value="" disabled>
									Select Type
								</MenuItem>
								{TYPE_LIST.map((item) => (
									<MenuItem key={item.value} value={item.value}>
										{item.name}
									</MenuItem>
								))}
							</Select>

							{/* Month dropdown only when Voucher is selected */}
							{data?.type === "VOUCHER" && (
								<Select
									multiple
									value={data?.months || []}
									onChange={(e) => setData((prev) => ({ ...prev, months: e.target.value }))}
									displayEmpty
									fullWidth
									renderValue={(selected) => (selected.length === 0 ? "Select Months" : selected.join(", "))}>
									{MONTH_LIST.map((month) => (
										<MenuItem
											key={month.value}
											value={month.value}
											sx={{
												"&.Mui-selected": {
													backgroundColor: "#6b6b6bff", // primary blue
													color: "#fff", // text color for visibility
												},
												"&.Mui-selected:hover": {
													backgroundColor: "#6b6b6bff", // slightly darker on hover
												},
											}}>
											{month.name}
										</MenuItem>
									))}
								</Select>
							)}

							{/* Buttons */}
							{data?.type && (
								<Box sx={{ display: "flex", gap: 2, mt: 2 }}>
									<Button variant="outlined" color="secondary" onClick={handleClear}>
										Clear
									</Button>
								</Box>
							)}
						</Box>
					</>
				)}

				<Divider sx={{ my: 2 }} />

				<Box display="flex" justifyContent="flex-end">
					<Button onClick={onClose} sx={{ mr: 1 }}>
						Cancel
					</Button>
					<Button variant="contained" disabled={!isFormValid} onClick={handleDownload}>
						Download
					</Button>
				</Box>
			</Box>
		</Modal>
	);
}

export default DownloadModal;
